<template>
  <div class="af-header-desktop container">
    <portal-target name="breadcrumb-destination"></portal-target>

    <div class="ml-auto">
      <p class="has-text-grey-3 is-size-7 mb-0">
        {{ $t("af:user_header.title.call_us") }}
      </p>

      <a
        class="has-text-weight-medium phone-number has-text-grey-dark"
        :href="`tel:${phoneNumber}`"
        >{{ phoneNumber }}</a
      >
    </div>
  </div>
</template>

<script>
import i18n from "@/plugins/i18n";

export default {
  name: "UserHeaderDesktop",
  computed: {
    phoneNumber() {
      return i18n.t("af:user_header.title.phone_number");
    },
  },
};
</script>

<style scoped lang="scss">
.af-header-desktop {
  display: none;
  flex-wrap: nowrap;
  align-items: center;
  background: transparent;
  padding: 1rem 0;

  .phone-number {
    font-size: 14px;
  }
}

@media only screen and (min-width: 769px) {
  .af-header-desktop {
    display: flex;
  }
}
</style>
